var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("entity-reader", {
    attrs: {
      entity: "research",
      id: _vm.id,
      "use-sharing": true,
      "api-name": "researchRequests"
    },
    scopedSlots: _vm._u(
      [
        {
          key: `reader`,
          fn: function({ doc }) {
            return [
              _c("label-value", {
                attrs: { name: "Main Team", value: doc.teamName }
              }),
              _c("label-value", {
                attrs: { name: "Reference", value: doc.reference }
              }),
              _c("label-value", {
                attrs: { name: "Research Period", value: doc.periodName }
              }),
              _c("label-value", {
                attrs: {
                  name: "Deadline",
                  value: _vm.deadlineDate(doc.deadline)
                }
              }),
              _c("label-value", {
                attrs: { name: "Player Name", value: doc.realName }
              }),
              _c("label-value", {
                attrs: { name: "Character Name", value: doc.characterName }
              }),
              _c("label-value", { attrs: { name: "Topic", value: doc.topic } }),
              _c("label-value", { attrs: { name: "Notes", value: doc.notes } }),
              _c("label-value-html", {
                attrs: { name: "Url", value: _vm.getLink(doc.url) }
              })
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }